import React, { Component } from 'react';
import { connect } from 'react-redux';

import { closeModal } from 'actions/modalActions';

// this higher order component wraps a Modal dialog.
// It allows modals to be centrally controlled,
// while launching and closing them from anywhere in the app

// the signature to use this HOC is:
// export default ModalDecorator( modalId )( ComponentToWrap )
// where:
//   modalId: is a string uniquely identifying the modal in the app, eg. 'my-cool-modal'
//   ComponentToWrap: is the modal component where ModalDecorator is called
export default function ModalDecorator(modalId) {
  return function (ComponentToWrap) {
    class ComponentWrapper extends Component {
      render() {
        // pass closeModal to the wrapped
        // component with { ...otherProps }
        const { isVisible, ...otherProps } = this.props;

        // if the modal state isVisible is true, add the modal
        // to the virtual DOM, otherwise render and empty div
        if (isVisible) {
          return <ComponentToWrap {...otherProps} />;
        }
        return <div className="hidden" />;
      }
    }

    function mapStateToProps(state) {
      return {
        isVisible: state.visibleModal.modalId === modalId
      };
    }

    return connect(mapStateToProps, { closeModal })(ComponentWrapper);
  };
}



// WEBPACK FOOTER //
// ./src/hocs/ModalDecorator.js